//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { mapModel } from 'src/util/helper';

import BenefitTableRow from 'src/components/payment/BenefitTableRow';
import PageHeader from 'src/components/payment/PageHeader';
import PricingBox from 'src/components/payment/PricingBox.vue';

export default {
	name: 'PaymentPackages',
	components: { BenefitTableRow, PageHeader, PricingBox },

	computed: {
		...mapState('subscription', ['pricing', 'stage']),
		...mapModel('subscription', ['period']),
		...mapGetters('vehicle', ['vehicleCount']),
	},

	methods: {
		setStage() {
			let stage = 'LT30';
			if (this.vehicleCount > 30 && this.vehicleCount <= 100) stage = 'LT100';
			if (this.vehicleCount > 100) stage = 'G100';
			this.$store.commit('subscription/UPDATE_SUBSCRIPTION', { stage });
		},
		onSelect(product) {
			this.$store.commit('subscription/UPDATE_SUBSCRIPTION', { product });

			const isOfferRequest = isNaN(this.pricing[this.stage][product][this.period]);

			if (isOfferRequest) return this.$router.push('/payment/offerrequest');

			return this.$router.push('/payment/checkout');
		},
	},

	mounted() {
		this.setStage();
	},

	watch: {
		vehicleCount() {
			this.setStage();
		},
	},

};
